import React from 'react';

/**
 * "Attach My Digital Business Card" switch used by every first-touch text setup
 * (card settings, vendor auto-outbound, drip welcome, AI bot opening message).
 * @param {{checked: boolean, onChange: (v: boolean) => void, id?: string, className?: string}} props
 * @returns {JSX.Element}
 */
export default function AttachBusinessCardToggle({ checked, onChange, id = 'attach-business-card', className = '' }) {
  return (
    <div className={`flex items-start gap-2 ${className}`}>
      <input
        id={id}
        data-testid={id}
        type="checkbox"
        className="mt-1 accent-civix-purple"
        checked={checked !== false}
        onChange={(e) => onChange(e.target.checked)}
      />
      <label htmlFor={id} className="cursor-pointer">
        <span className="text-sm text-white/80 font-medium">Attach My Digital Business Card</span>
        <span className="block text-xs text-white/50 mt-0.5">
          Automatically appends your digital business card link to the initial introductory text sent to new leads.
        </span>
      </label>
    </div>
  );
}
